import type { SVGProps } from "react";
import React from "react";

export function GlobeIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g stroke={props.stroke ?? "currentColor"} strokeWidth="1.2" strokeLinecap="round" fill="none">
        <circle cx="8" cy="8" r="6.4" />
        <path d="M8 1.6c1.7 1.75 2.6 4.05 2.6 6.4S9.7 12.65 8 14.4" />
        <path d="M8 1.6C6.3 3.35 5.4 5.65 5.4 8s.9 4.65 2.6 6.4" />
        <path d="M2.1 5.9h11.8M2.1 10.1h11.8" />
      </g>
    </svg>
  );
}
